module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"state":"State","request":{"get_sector_states":"Something went wrong while trying to get all possible sector states.","sector_updated":"Sector updated.","sector_update":"Something went wrong while trying to update the sector."}},"ko":{"state":"상태","request":{"get_sector_states":null,"sector_updated":null,"sector_update":null}}}')
  delete Component.options._Ctor
}
